// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"493":"8babe6e3","1329":"fe1be075","2166":"9592cee9","2681":"d19fbee3","4562":"b9fa37b5","5683":"7b384b9d","7212":"29eb67ac","8817":"d063a88d"}[chunkId] + ".chunk.css";
};